<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670 mt-4`"
        :hideFooter="false"
        :newLayout="true"
    >
        <template slot="card-header">
            <h1 class="text-center" v-translate>Enter your billing address</h1>
        </template>
        <template slot="card-body">
            <form
                method="POST"
                :action="$laraRoute('mysubs.upgrade-subscription')"
                @submit.prevent="handleForm"
                aria-label="Set billing address"
                id="enrol-form"
                novalidate
                ref="form"
            >
                <div class="form-group row">
                    <div class="col-md-6 offset-md-4">
                        <Checkbox
                            :label="'Same as my home address.' | translate"
                            wrapperClass="ml-2"
                            module="Enrolment"
                            modelName="use_home_as_billing"
                            :changeHandler="useHomeAddress"
                        />
                    </div>
                </div>
                <div
                    class="form-group justify-content-center align-items-center row"
                >
                    <label for="country" class="col-md-3" v-translate
                        >Country</label
                    >

                    <div class="col-md-8 col-lg-7" v-if="countries.length">
                        <CountrySelect
                            :required="true"
                            :options="countries"
                            :hasValue="
                                billing_country ? billing_country : false
                            "
                            :setCountry="setBillingCountry"
                            :getIsoCodeFromName="getIsoCodeFromName"
                            :label="'billing_country'"
                            :handler="countryHandler"
                        >
                            <template slot-scope="{ slotKey }">
                                <span
                                    :data-key="slotKey"
                                    :class="`iti-flag ${slotKey.toLowerCase()}`"
                                ></span
                                >&nbsp;
                            </template>
                        </CountrySelect>
                        <InlineError :errors="errors" type="billing_country" />
                    </div>
                    <div class="col-md-8 col-lg-7 loader loader--inline" v-else>
                        <loader />
                    </div>
                </div>
                <div
                    class="form-group justify-content-center align-items-start row"
                >
                    <label for="billing_house_name" class="col-md-3" v-translate
                        >House Name</label
                    >

                    <div class="col-md-8 col-lg-7">
                        <Input
                            id="billing_house_name"
                            name="billing_house_name"
                            :rule="{
                                rules: {
                                    required: user.billing_house_number
                                        ? false
                                        : true
                                }
                            }"
                            model="user.billing_house_name"
                            module="Enrolment"
                        />
                    </div>
                </div>
                <div
                    class="form-group justify-content-center align-items-start row"
                >
                    <label
                        for="billing_house_number"
                        class="col-md-3"
                        v-translate
                        >House Number</label
                    >

                    <div class="col-md-8 col-lg-7">
                        <Input
                            id="billing_house_number"
                            name="billing_house_number"
                            :rule="{
                                rules: {
                                    required: user.billing_house_name
                                        ? false
                                        : true
                                }
                            }"
                            model="user.billing_house_number"
                            module="Enrolment"
                        />
                    </div>
                </div>
                <div
                    class="form-group justify-content-center align-items-center row"
                >
                    <label for="street_address" class="col-md-3" v-translate
                        >Street Address</label
                    >

                    <div class="col-md-8 col-lg-7">
                        <AutoCompleteInput
                            id="street_address"
                            name="billing_street"
                            model="user.billing_street"
                            module="Enrolment"
                            :autocompleteOptions="predictions"
                            :emulatePlaceChange="emulatePlaceChange"
                            :changeHandler="callAutoComplete"
                        />
                    </div>
                </div>
                <div
                    class="form-group justify-content-center align-items-center row"
                    v-show="showState()"
                >
                    <label
                        for="state"
                        class="col-md-3"
                        v-show="!showCounty()"
                        v-translate
                        >State</label
                    >
                    <label
                        for="state"
                        class="col-md-3"
                        v-show="showCounty()"
                        v-translate
                        >County</label
                    >

                    <div class="col-md-8 col-lg-7">
                        <Input
                            :rule="'required'"
                            validateAs="state"
                            id="state"
                            name="billing_state"
                            errorType="billing_state"
                            model="user.billing_state"
                            module="Enrolment"
                            :required="true"
                            :lazy="false"
                        />
                    </div>
                </div>
                <div
                    class="form-group justify-content-center align-items-center row"
                >
                    <label for="city" class="col-md-3" v-translate>City</label>

                    <div class="col-md-8 col-lg-7">
                        <Input
                            :rule="'required'"
                            validateAs="city"
                            id="city"
                            name="billing_city"
                            errorType="billing_city"
                            model="user.billing_city"
                            module="Enrolment"
                            :required="true"
                            :lazy="false"
                        />
                    </div>
                </div>
                <div
                    class="form-group justify-content-center align-items-center row"
                >
                    <label
                        for="postcode"
                        class="col-md-3"
                        v-show="showPostcode()"
                        v-translate
                        >Postcode</label
                    >
                    <label
                        for="postcode"
                        class="col-md-3"
                        v-show="!showPostcode()"
                        v-translate
                        >Zipcode</label
                    >

                    <div class="col-md-8 col-lg-7">
                        <Input
                            :rule="'required'"
                            validateAs="postcode"
                            id="postcode"
                            name="billing_postcode"
                            errorType="billing_postcode"
                            model="user.billing_postcode"
                            module="Enrolment"
                            :required="true"
                            :lazy="false"
                        />
                    </div>
                </div>
                <input type="submit" style="display: none;" />
            </form>
        </template>
        <template slot="card-footer">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
            </div>

            <div class="row justify-content-center align-items-end">
                <div class="col-12 col-md-auto text-center ml-md-auto">
                    <button
                        class="btn btn-hollow btn--chunky border-white color-white border-white--lightest"
                        v-translate
                        @click.prevent="cancel"
                    >
                        Changed My Mind
                    </button>
                </div>
                <div class="col-12 col-md-auto mt-2 mt-md-0">
                    <LoaderedButton
                        :clickHandler="submitForm"
                        :content="'Confirm' | translate"
                        btnClasses="btn btn-primary"
                    />
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions, mapMutations, mapState } from "vuex";
import Card from "@C/Card.vue";
import Input from "@C/Forms/Input";
import InlineError from "@C/Forms/InlineError";
import CountrySelect from "@C/CountrySelect";
import AutoCompleteInput from "@C/AutoCompleteInput";
import Checkbox from "@C/Checkbox";
import LoaderedButton from "@C/LoaderedButton";
import EnrolmentMixin from "@M/enrolment";
import validator from "@M/validationWrapper";
import autocomplete from "@M/autocomplete";

export default {
    name: "Billing",
    created() {
        this.getOrganisedCountries();
    },
    mounted() {
        this.setOriginalBilling();
    },
    data: function() {
        return {
            original_billing_address: {},
            autocompleteIdentifier: "billing"
        };
    },
    methods: {
        ...mapActions(["getOrganisedCountries"]),
        ...mapActions("Enrolment", ["resetBillingFields", "setBillingFields"]),
        ...mapActions("MySubscriptions", ["initiateSubscriptionUpgrade"]),
        ...mapMutations("Widget", ["setSelectedUpgrade"]),
        ...mapMutations("Enrolment", [
            "setBillingCountry",
            "setUseHomeAsBilling"
        ]),
        submitForm() {
            this.$refs.form.dispatchEvent(
                new Event("submit", { cancelable: true })
            );
        },
        cancel() {
            // Clear the selection and redirect
            this.setSelectedUpgrade({});
            return this.$router.push({ name: "my-subscriptions" });
        },
        formHandler(e) {
            this.initiateSubscriptionUpgrade();
        },
        showPostcode: function() {
            return (
                this.user.billing_country == "United Kingdom" ||
                typeof this.user.billing_country == "undefined"
            );
        },
        showState: function() {
            return (
                this.billing_country == "United States" ||
                this.billing_country == "United Kingdom"
            );
        },
        showCounty() {
            return this.billing_country == "United Kingdom";
        },
        useHomeAddress: function() {
            let checked = this.use_home_as_billing;

            if (checked) {
                this.setBillingFields({
                    billing_country: this.home_country,
                    billing_postcode: this.home_postcode,
                    billing_city: this.home_city,
                    billing_house_name: this.home_house_name,
                    billing_house_number: this.home_house_number,
                    billing_street: this.home_street,
                    billing_state: this.home_state
                });
            } else {
                this.setBillingFields({
                    billing_country: this.original_billing_address.country,
                    billing_postcode: this.original_billing_address.postcode,
                    billing_city: this.original_billing_address.city,
                    billing_house_name: this.original_billing_address
                        .house_name,
                    billing_house_number: this.original_billing_address
                        .house_number,
                    billing_street: this.original_billing_address.street,
                    billing_state: this.original_billing_address.state
                });
            }
        },
        /**
         * After we've retrieved the user record take note of the billing address
         * so we can retrieve it later if they tick and then untick the "same as home address" checkbox
         */
        setOriginalBilling() {
            this.original_billing_address = Object.assign(
                {},
                {
                    country: this.billing_country,
                    postcode: this.billing_postcode,
                    city: this.billing_city,
                    state: this.billing_state,
                    house_name: this.billing_house_name,
                    house_number: this.billing_house_number,
                    street: this.billing_street
                }
            );

            this.setUseHomeAsBilling(this.usingHomeAsBilling);
        },
        countryHandler(e, firstRun = false) {
            let val = e.value || e.target.value;
            this.getIsoCodeFromName(val, this.countries);
            this.setBillingCountry(val);

            if (!firstRun) {
                this.resetBillingFields();
            }
        }
    },
    computed: {
        ...mapState({
            use_home_as_billing: state => state.Enrolment.use_home_as_billing,
            usingHomeAsBilling: state =>
                state.Enrolment.user.profile.use_home_as_billing,
            billing_country: state => state.Enrolment.user.billing_country,
            billing_house_number: state =>
                state.Enrolment.user.billing_house_number,
            billing_street: state => state.Enrolment.user.billing_street,
            home_country: state => state.Enrolment.user.home_country,
            home_house_name: state => state.Enrolment.user.home_house_name,
            home_house_number: state => state.Enrolment.user.home_house_number,
            home_street: state => state.Enrolment.user.home_street,
            home_state: state => state.Enrolment.user.home_state,
            home_city: state => state.Enrolment.user.home_city,
            home_postcode: state => state.Enrolment.user.home_postcode
        }),
        ...mapState("Enrolment", ["user"]),
        ...mapFields("Enrolment", [
            "user.billing_state",
            "user.billing_city",
            "user.billing_postcode"
        ]),
        ...mapState(["countries"]),
        disabled() {
            return this.use_home_as_billing;
        }
    },
    components: {
        Card,
        Input,
        InlineError,
        Checkbox,
        AutoCompleteInput,
        CountrySelect,
        LoaderedButton
    },
    mixins: [EnrolmentMixin, validator, autocomplete("Enrolment", "billing")]
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/MySubscriptions/Billing.vue